import { render, staticRenderFns } from "./flow_header.vue?vue&type=template&id=36fa78b5&scoped=true"
import script from "./flow_header.vue?vue&type=script&lang=js"
export * from "./flow_header.vue?vue&type=script&lang=js"
import style0 from "./flow_header.vue?vue&type=style&index=0&id=36fa78b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa78b5",
  null
  
)

export default component.exports